import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { BreadCrumbItem } from '../../models/breadcrumb.model';
import { IconService } from '../../services/icon.service';
import { ProjectNode } from '../../models/projectNode';
import { ProjectModel } from '../../models/projectModel';

@Component({
  selector: 'app-breadcrumb-navigation',
  templateUrl: './breadcrumb-navigation.component.html',
  styleUrls: ['./breadcrumb-navigation.component.scss'],
})
export class BreadcrumbNavigationComponent {
  @Input() items!: Array<BreadCrumbItem>;
  @Output() pressedItemIndex: EventEmitter<number> = new EventEmitter<number>();
  @Output() nodeSelected: EventEmitter<ProjectNode> =
    new EventEmitter<ProjectNode>();
  @Output() modelSelected: EventEmitter<ProjectModel> =
    new EventEmitter<ProjectModel>();

  viewAllBreadcrumbClick(item: BreadCrumbItem, index: number) {
    this.pressedItemIndex.emit(Math.max(0, index - 1));
    this.nodeSelected.emit(item.currentNode);
  }

  selectNode(index: number, node: ProjectNode) {
    this.pressedItemIndex.emit(index);
    this.nodeSelected.emit(node);
  }

  selectModel(index: number, model: ProjectModel) {
    this.pressedItemIndex.emit(index);
    this.modelSelected.emit(model);
  }
}
